//* node modules
import { PatternFormat } from "react-number-format";
import { isValidPhoneNumber } from "react-phone-number-input";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { Select } from "react-functional-select";
import BootstrapForm from "react-bootstrap/Form";
import * as yup from "yup";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  FormFeedback,
  FormText,
  Button,
  Label,
} from "reactstrap";

//*Components
import PrivacyDataProtectionModal from "./PrivacyDataProtectionModal";
import DataDisclosureTextModal from "./DataDisclosureTextModal";

//* Style files
import "./index.scss";
import plus from "../../../../assets/images/+.png";

const CustomFormError = ({ children }) => (
  <span
    style={{
      width: "100%",
      marginTop: "0.25rem",
      fontSize: "0.875em",
      color: "#dc3545",
    }}
  >
    {children}
  </span>
);

const ApplicationForm = () => {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showDataDisclosure, setShowDataDisclosure] = useState(false);
  const [uploading, setUploading] = useState(false);

  const {
    control,
    handleSubmit,
    register,
    reset,
    clearErrors,
    setError,
    unregister,
    getValues,
    setValue,
    getFieldState,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "all",
  });

  const fileSchema = yup
    .mixed()
    .test("fileSize", "The file is too large", (value, context) => {
      return value && value[0] && Math.round(value[0].size / 1024) <= 11264;
    });

  const [universities] = useState([
    { label: "9 Eylul University", value: "9 Eylul University" },
    { label: "Bogazici University", value: "Bogazici University" },
    { label: "Ege University", value: "Ege University" },
    { label: "Galatasaray University", value: "Galatasaray University" },
    { label: "Hacettepe University", value: "Hacettepe University" },
    {
      label: "Ihsan Dogramaci Bilkent University",
      value: "Ihsan Dogramaci Bilkent University",
    },
    {
      label: "Istanbul Technical University",
      value: "Istanbul Technical University",
    },
    { label: "Istanbul University", value: "Istanbul University" },
    { label: "Koc University", value: "Koc University" },
    { label: "Marmara University", value: "Marmara University" },
    {
      label: "Middle East Technical University",
      value: "Middle East Technical University",
    },
    { label: "Ozyegin University", value: "Ozyegin University" },
    { label: "Sabanci University", value: "Sabanci University" },
    {
      label: "Yildiz Technical University",
      value: "Yildiz Technical University",
    },
  ]);

  const [departments, setDepartments] = useState([]);

  const [englishLevels] = useState([
    { label: "Beginner-A1", value: "Beginner-A1" },
    { label: "Elementary-A2", value: "Elementary-A2" },
    { label: "Intermediate-B1", value: "Intermediate-B1" },
    { label: "Upper intermediate-B2", value: "Upper intermediate-B2" },
    { label: "Advanced-C1", value: "Advanced-C1" },
    { label: "Proficient-C2", value: "Proficient-C2" },
  ]);

  const [classes] = useState([
    {
      label: "Freshman - 1st grade university student",
      value: "Freshman - 1st grade university student",
    },
    {
      label: "Sophomore - 2nd grade university student",
      value: "Sophomore - 2nd grade university student",
    },
    {
      label: "Junior - 3rd grade university student",
      value: "Junior - 3rd grade university student",
    },
    {
      label: "Senior - 4th grade university student",
      value: "Senior - 4th grade university student",
    },
    { label: "New Graduate", value: "New Graduate" },
    { label: "Master Student", value: "Master Student" },
  ]);

  const [experiences] = useState([
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ]);

  const [camps] = useState([
    { label: "Engineering", value: "Engineering" },
    { label: "FMCG", value: "FMCG" },
    { label: "Finance&Audit", value: "Finance&Audit" },
    { label: "Technology", value: "Technology" },
  ]);

  const fetchDepartment = () => {
    const url = "https://api.webeyondcreative.com/api/form/departmenteng";
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios
      .get(url, {
        headers: {
          "X-Api-Token": token,
        },
      })
      .then((response) => {
        const departments = response.data;
        setDepartments(
          departments.map((department) => ({
            value: department.name,
            label: department.name,
          }))
        );
      });
  };

  const submitForm = (data) => {
    setUploading(true);
    axios.defaults.headers["X-Api-Token"] =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
    axios.defaults.headers["Access-Control-Allow-Credentials"] = "true";

    const formData = new FormData();
    [
      "university",
      "department",
      "experience",
      "english-level",
      "camp",
      "class",
    ].forEach((item) => {
      data[item] = data[item].value;
    });

    for (const [key, value] of Object.entries(data)) {
      if (key == "file") {
        formData.append(key, value[0]);
      } else {
        formData.append(key, value);
      }
    }

    axios
      .post(
        "https://api.webeyondcreative.com/api/form/store/we_careerplus202211",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        if (response.data.exists === "success") {
          setUploading(false);
          toast.success(
            "Your application has been sent. Thank you for your attention."
          );
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else if (response.data.exists === "db_error") {
          setUploading(false);
          toast.error("Your application hasn't been sent!");
        } else if (response.data.errors.email) {
          setUploading(false);
        }
      })
      .catch((error) => {
        setUploading(false);
        toast.error("This e-mail address has already been applied for!");
        console.log(error);
      });
  };

  useEffect(() => {
    fetchDepartment();
  }, []);

  return (
    <section className="application-form-section">
      <Container>
        <Row>
          <Col>
            <h3 className="title">
              APPLICATION <br /> FORM
            </h3>
          </Col>
        </Row>
      </Container>
      <div className="black-card">
        <img className="plus" src={plus} alt="plus" />
        <Container>
          <Row>
            <Col sm="12" md="8" lg="8" className="pt-5">
              <Form onSubmit={handleSubmit(submitForm)}>
                <Row>
                  <Col sm="12" md="6" lg="6">
                    <FormGroup>
                      <BootstrapForm.Control
                        isInvalid={!!errors.name}
                        placeholder="Name"
                        {...register("name", {
                          required: "This field is required!",
                        })}
                      />
                      <FormFeedback>{errors.name?.message}</FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm="12" md="6" lg="6">
                    <FormGroup>
                      <BootstrapForm.Control
                        isInvalid={!!errors.surname}
                        placeholder="Surname"
                        {...register("surname", {
                          required: "This field is required!",
                        })}
                      />
                      <FormFeedback>{errors.surname?.message}</FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12" md="6" lg="6">
                    <FormGroup>
                      <BootstrapForm.Control
                        isInvalid={!!errors.email}
                        placeholder="E-mail"
                        {...register("email", {
                          required: "This field is required!",
                          pattern: {
                            value:
                              /\b[\+\w\.-]+@((?![\w\.-]+\.edu).)[\w\.-]+\.\w{2,7}\b/,
                            message: "Incorrect email format!",
                          },
                        })}
                      />
                      <FormText color="danger">
                        *Applications with edu.tr extension will not be
                        evaluated.
                      </FormText>
                      <FormFeedback>{errors.email?.message}</FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm="12" md="6" lg="6">
                    <Controller
                      control={control}
                      name="phone"
                      rules={{
                        required: "Please enter your phone number",
                        validate: (value) =>
                          isValidPhoneNumber(value) ||
                          "The phone number is invalid",
                      }}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { error },
                      }) => (
                        <FormGroup>
                          <PatternFormat
                            name={name}
                            getInputRef={ref}
                            onChange={onChange}
                            onBlur={onBlur}
                            value={value}
                            disabled={isSubmitting}
                            customInput={BootstrapForm.Control}
                            isInvalid={!!error}
                            placeholder="Phone"
                            format="+90 ### ### ## ##"
                            mask="_"
                          />
                          <FormFeedback>{error && error.message}</FormFeedback>
                        </FormGroup>
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="12" md="6" lg="6">
                    <Controller
                      control={control}
                      name="university"
                      rules={{ required: "Please select university" }}
                      render={({
                        field: { onChange, onBlur, value, name, ref, id },
                        fieldState: { error },
                      }) => (
                        <FormGroup aria-invalid={!!error}>
                          <Select
                            id={id}
                            ref={ref}
                            name={name}
                            isClearable
                            options={universities}
                            themeConfig={{
                              control: {
                                backgroundColor: "white",
                                borderRadius: 0,
                                height: "47px",
                              },
                            }}
                            placeholder="Universities"
                            isInvalid={!!error}
                            onOptionChange={onChange}
                            onInputBlur={onBlur}
                            value={value}
                          />
                          <CustomFormError>
                            {error && error.message}
                          </CustomFormError>
                        </FormGroup>
                      )}
                    />
                  </Col>
                  <Col sm="12" md="6" lg="6">
                    <Controller
                      control={control}
                      name="department"
                      rules={{ required: "Please select department" }}
                      render={({
                        field: { onChange, onBlur, value, name, ref, id },
                        fieldState: { error },
                      }) => (
                        <FormGroup aria-invalid={!!error}>
                          <Select
                            id={id}
                            ref={ref}
                            name={name}
                            isClearable
                            options={departments}
                            themeConfig={{
                              control: {
                                backgroundColor: "white",
                                borderRadius: 0,
                                height: "47px",
                              },
                            }}
                            placeholder="Departments"
                            isInvalid={!!error}
                            onOptionChange={onChange}
                            onInputBlur={onBlur}
                            value={value}
                          />
                          <CustomFormError>
                            {error && error.message}
                          </CustomFormError>
                        </FormGroup>
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="12" md="6" lg="6">
                    <Controller
                      control={control}
                      name="experience"
                      rules={{ required: "Please select experience" }}
                      render={({
                        field: { onChange, onBlur, value, name, ref, id },
                        fieldState: { error },
                      }) => (
                        <FormGroup aria-invalid={!!error}>
                          <Select
                            id={id}
                            ref={ref}
                            name={name}
                            isClearable
                            options={experiences}
                            themeConfig={{
                              control: {
                                backgroundColor: "white",
                                borderRadius: 0,
                                height: "47px",
                              },
                            }}
                            placeholder="Do you have an experience in abroad?"
                            isInvalid={!!error}
                            onOptionChange={onChange}
                            onInputBlur={onBlur}
                            value={value}
                          />
                          <CustomFormError>
                            {error && error.message}
                          </CustomFormError>
                        </FormGroup>
                      )}
                    />
                  </Col>
                  <Col sm="12" md="6" lg="6">
                    <Controller
                      control={control}
                      name="class"
                      rules={{ required: "Please select class" }}
                      render={({
                        field: { onChange, onBlur, value, name, ref, id },
                        fieldState: { error },
                      }) => (
                        <FormGroup aria-invalid={!!error}>
                          <Select
                            id={id}
                            ref={ref}
                            name={name}
                            isClearable
                            options={classes}
                            themeConfig={{
                              control: {
                                backgroundColor: "white",
                                borderRadius: 0,
                                height: "47px",
                              },
                            }}
                            placeholder="Class"
                            isInvalid={!!error}
                            onOptionChange={onChange}
                            onInputBlur={onBlur}
                            value={value}
                          />
                          <CustomFormError>
                            {error && error.message}
                          </CustomFormError>
                        </FormGroup>
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="12" md="6" lg="6">
                    <Controller
                      control={control}
                      name="english-level"
                      rules={{ required: "Please select English Level" }}
                      render={({
                        field: { onChange, onBlur, value, name, ref, id },
                        fieldState: { error },
                      }) => (
                        <FormGroup aria-invalid={!!error}>
                          <Select
                            id={id}
                            ref={ref}
                            name={name}
                            isClearable
                            options={englishLevels}
                            themeConfig={{
                              control: {
                                backgroundColor: "white",
                                borderRadius: 0,
                                height: "47px",
                              },
                            }}
                            placeholder="English Level"
                            isInvalid={!!error}
                            onOptionChange={onChange}
                            onInputBlur={onBlur}
                            value={value}
                          />
                          <CustomFormError>
                            {error && error.message}
                          </CustomFormError>
                        </FormGroup>
                      )}
                    />
                  </Col>
                  <Col sm="12" md="6" lg="6">
                    <Controller
                      control={control}
                      name="camp"
                      rules={{ required: "Please select camp" }}
                      render={({
                        field: { onChange, onBlur, value, name, ref, id },
                        fieldState: { error },
                      }) => (
                        <FormGroup aria-invalid={!!error}>
                          <Select
                            id={id}
                            ref={ref}
                            name={name}
                            isClearable
                            options={camps}
                            themeConfig={{
                              control: {
                                backgroundColor: "white",
                                borderRadius: 0,
                                height: "47px",
                              },
                            }}
                            placeholder="Which camp do you want to join?"
                            isInvalid={!!error}
                            onOptionChange={onChange}
                            onInputBlur={onBlur}
                            value={value}
                          />
                          <CustomFormError>
                            {error && error.message}
                          </CustomFormError>
                        </FormGroup>
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="12" md="12" lg="12">
                    <FormGroup>
                      <BootstrapForm.Control
                        className="textarea"
                        isInvalid={!!errors.message}
                        placeholder="Why do you want to join Career Plus?"
                        {...register("message", {
                          required: "This field is required!",
                        })}
                        as="textarea"
                      />
                      <FormFeedback>{errors.message?.message}</FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12" md="12" lg="12">
                    <FormGroup className="checkboxes">
                      <BootstrapForm.Check
                        isInvalid={!!errors.PrivacyPolicy}
                        type="checkbox"
                        {...register("PrivacyPolicy", {
                          required: "Required field",
                        })}
                      />

                      <Label check required>
                        Within the framework of the{" "}
                        <span
                          onClick={() => {
                            setShowPrivacy(true);
                          }}
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          Privacy and Data Protection Policy
                        </span>
                        , I consent to be contacted for marketing and
                        communication purposes.
                        <FormFeedback>
                          {errors.PrivacyPolicy?.message}
                        </FormFeedback>
                      </Label>
                    </FormGroup>
                    <PrivacyDataProtectionModal
                      show={showPrivacy}
                      setShow={setShowPrivacy}
                    />
                  </Col>
                  <Col sm="12" md="12" lg="12">
                    <FormGroup className="checkboxes">
                      <BootstrapForm.Check
                        isInvalid={!!errors.acceptReadData}
                        type="checkbox"
                        {...register("acceptReadData", {
                          required: "Required field",
                        })}
                      />
                      <Label check required>
                        I have read and accept the{" "}
                        <span
                          onClick={() => {
                            setShowDataDisclosure(true);
                          }}
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          Data Disclosure Text
                        </span>
                        .
                        <FormFeedback>
                          {errors.acceptReadData?.message}
                        </FormFeedback>
                      </Label>
                    </FormGroup>
                    <DataDisclosureTextModal
                      show={showDataDisclosure}
                      setShow={setShowDataDisclosure}
                    />
                  </Col>
                </Row>
                <FormText color="danger">
                  *Upload your CV as PDF. Applications that are not uploaded as
                  name_surname.pdf will not be accepted.
                </FormText>

                <BootstrapForm.Group className="d-flex flex-row">
                  <BootstrapForm.Control
                    id="uploadCv"
                    type="file"
                    {...register("file", {
                      required: "This field is required!.",
                      validate: async (value) =>
                        await fileSchema
                          .validate(value, { strict: true })
                          .catch((err) => "File is too big"),
                    })}
                    accept="application/pdf"
                  />
                  <Label className="uploadCv" for="uploadCv">
                    Upload CV
                  </Label>
                  <div className="d-flex flex-column justify-content-center">
                    <FormText color="white">
                      {watch("file") && watch("file.0")
                        ? watch("file.0").name
                        : "CV (max 10 mb)"}
                    </FormText>
                    <FormText color="danger">{errors.file?.message}</FormText>
                  </div>
                </BootstrapForm.Group>

                {/* <Controller
                  control={control}
                  name="file"
                  rules={{
                    required: "This field is required!",
                    validate: {
                      lessThan10MB: async (files) =>
                        (await files[0]?.size) <= 2000000 ||
                        "The max file size should be 10MB!",
                    },
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref },
                    fieldState: { error },
                  }) => (
                    <BootstrapForm.Group>
                      <BootstrapForm.Control
                        type="file"
                        inputRef={ref}
                        name={name}
                        onChange={(e) => {
                          setValue("file", e.target.files);
                        }}
                        onBlur={onBlur}
                        isInvalid={!!error}
                      />

                      <CustomFormError>
                        {error && error.message}
                        {console.log(watch("file"))}
                        {console.log(errors)}
                      </CustomFormError>
                    </BootstrapForm.Group>
                  )}
                /> */}

                {/* <FormGroup>
                  <BootstrapForm.Control
                    isInvalid={!!errors.file}
                    id="uploadCv"
                    type="file"
                    {...register("file", {
                      required: "Required field",
                    })}
                    accept="application/pdf"
                  />
                  <Label className="uploadCv" for="uploadCv">
                    Upload CV
                  </Label>

                  {watch("file") && watch("file").length > 0 ? (
                    <FormText color="white">
                      {watch("file")[0].name +
                        " boyut : " +
                        watch("file")[0].size}
                    </FormText>
                  ) : (
                    <FormText color="danger">Dosya seçilmedi.</FormText>
                  )}
                  {console.log(watch("file"))}
                </FormGroup> */}

                <FormGroup>
                  <Button className="submit-button" type="submit">
                    {uploading && (
                      <div
                        size="sm"
                        className="spinner-border text-light"
                        role="status"
                      >
                        <span className="sr-only"></span>
                      </div>
                    )}
                    {!uploading && "Apply"}
                  </Button>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default ApplicationForm;
